import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import ChantierUpdate from './ChantierUpdate/ChantierUpdate';
import {faTrashAlt, faPencilAlt, faAngleRight, faAnglesRight, faAnglesLeft, faAngleLeft} from '@fortawesome/free-solid-svg-icons';
import {Row, Col} from 'react-bootstrap';
import {MDBContainer, MDBRow} from 'mdb-react-ui-kit';

/**
 * La vue de la liste des chantiers
 * @param {*} props props
 * @return {JSX}
 */
function ChantierView(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState(null);

  /**
  * Ouvre le modal
  */
  function openModal() {
    document.getElementById('navbar').classList.add('navbar-hidden');
    document.body.classList.add('modal-open');
    setIsModalOpen(true);
  }

  const closeModal = () => {
    document.getElementById('navbar').classList.remove('navbar-hidden');
    document.body.classList.remove('modal-open');
    setIsModalOpen(false);
  };

  const onClickUpdate = (chantier) => {
    setSelectedPlace(chantier);
    setIsUpdate(true);
    openModal();
  };

  return (
    <div className="chantier-container">
      {isModalOpen && (
        <MDBContainer className="modal" >
          <MDBRow className="d-flex justify-content-center align-items-center h-100 banktable-modal-content">
            <ChantierUpdate selectedPlace={selectedPlace} closeModal={closeModal} setPlaces={props.setPlaces} isUpdate={isUpdate}/>
          </MDBRow>
        </MDBContainer>)}
      <h2 className="chantier-heading">Liste de projets</h2>
      <input
        type="text"
        value={props.searchInput}
        onChange={props.handleSearchInput}
        className="chantier-input-hidden"
        placeholder="Barre de recherche" />
      <div className="chantier-wrapper">
        <div className="chantier-table">
          <div className="chantier-search-container">
            <input
              type="text"
              value={props.searchInput}
              onChange={props.handleSearchInput}
              className="chantier-input"
              placeholder="Barre de recherche" />
            <div className="chantier-pagination-buttons">
              {localStorage.getItem('admin') === '1' ?
              <button
                onClick={() => {
                  setIsUpdate(false);
                  openModal();
                }}
                key="+"
                className="chantier-pagination-button">
                Ajouter
              </button> : '' }
              {[<FontAwesomeIcon key="11" icon={faAnglesLeft} />,
                <FontAwesomeIcon key="22" icon={faAngleLeft} />,
                <FontAwesomeIcon key="33" icon={faAngleRight} />,
                <FontAwesomeIcon key="44" icon={faAnglesRight} />].map((symbol, index) => {
                const newPage =
              index === 0 ?
                1 :
                index === 1 ?
                props.currentPage - 1 :
                index === 2 ?
                props.currentPage + 1 :
                Math.ceil(props.places.length / props.pageSize);

                return (
                  <React.Fragment key={index}>
                    <button
                      className="chantier-pagination-button"
                      onClick={() => props.handlePageChange(newPage)}
                      disabled={props.isButtonDisabled(symbol)}>
                      {symbol}
                    </button>
                  </React.Fragment>
                );
              })}

            </div>
          </div>
          <div className="chantier-table">
            <Row key="1" className="chantier-row chantier-header">
              <Col md={3} className="chantier-cell">
              Nom
              </Col>
              <Col md={5} className="chantier-cell">
              Adresse
              </Col>
              <Col md={2} className="chantier-cell ">
              Téléphone
              </Col>
              <Col md={1} className="chantier-cell">
              # Contrat
              </Col>
              <Col md={1} className="chantier-cell">
              </Col>
            </Row>
            {props.displayedPlaces.map((place, index) => (
              <React.Fragment key={index} >
                <Row key={index} className="chantier-row chantier-row-cell-click">
                  <Col md={3} className="chantier-cell chantier-cell-click" data-title="Nom" onClick={() => props.navigateId(place.id)}>
                    {place.client_name}
                  </Col>
                  <Col md={5} className="chantier-cell chantier-cell-click" data-title="Adresse" onClick={() => props.navigateId(place.id)}>
                    {place.name}
                  </Col>
                  <Col md={2} className="chantier-cell chantier-cell-click" data-title="Téléphone" onClick={() => props.navigateId(place.id)}>
                    {place.phone}
                  </Col>
                  <Col md={1} className="chantier-cell chantier-cell-click" data-title="# Contrat" onClick={() => props.navigateId(place.id)}>
                    {place.contrat}
                  </Col>

                  <Col md={1} className="chantier-cell chantier-cell-center">
                    {localStorage.getItem('admin') === '1' ?
                  <React.Fragment>
                    <FontAwesomeIcon className="chantier-souris" icon={faPencilAlt} onClick={() => {
                      onClickUpdate(place);
                    }}
                    style={{marginRight: '35px', fontSize: '25px'}} />
                    <FontAwesomeIcon className="chantier-souris" style={{fontSize: '25px'}} icon={faTrashAlt} onClick={() => props.supprimer(place.id, place.name)} />
                  </React.Fragment> : '' }
                  </Col>
                </Row>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChantierView;
